import { defineStore } from "pinia";
import { ref } from "vue";

import { type Nullable, type Stream } from "shared/types";

export const useFocusedStreamStore = defineStore("focusedStream", () => {
  const focusedStream = ref<Nullable<Stream>>(null);
  const focusedBookmarkStream = ref<Nullable<Stream>>(null);
  const focusedSocialStream = ref<Nullable<Stream>>(null);

  const focusedBookmarkStreamTimeout =
    ref<Nullable<ReturnType<typeof setTimeout>>>(null);

  const focusedSocialStreamTimeout =
    ref<Nullable<ReturnType<typeof setTimeout>>>(null);

  function setFocusedStream(stream: Nullable<Stream>) {
    focusedStream.value = stream;
  }

  function setFocusedBookmarkStream(stream: Stream) {
    focusedBookmarkStream.value = stream;

    if (focusedBookmarkStreamTimeout.value) {
      clearTimeout(focusedBookmarkStreamTimeout.value);
      focusedBookmarkStreamTimeout.value = null;
    }

    focusedBookmarkStreamTimeout.value = setTimeout(() => {
      focusedBookmarkStream.value = null;
    }, 1000);
  }

  function setFocusedSocialStream(stream: Stream) {
    focusedSocialStream.value = stream;

    if (focusedSocialStreamTimeout.value) {
      clearTimeout(focusedSocialStreamTimeout.value);
      focusedSocialStreamTimeout.value = null;
    }

    focusedSocialStreamTimeout.value = setTimeout(() => {
      focusedSocialStream.value = null;
    }, 1000);
  }

  return {
    focusedBookmarkStream,
    focusedBookmarkStreamTimeout,
    focusedSocialStream,
    focusedSocialStreamTimeout,
    focusedStream,

    setFocusedBookmarkStream,
    setFocusedSocialStream,
    setFocusedStream,
  };
});

export default useFocusedStreamStore;
